import React from "react";
import { FaAndroid, FaApple } from "react-icons/fa";
import { Modal, Button } from "antd";
import DownloadOnAppleStore from "../svgs/DownloadOnAppleStore";
const DownloadWegetherModal = ({
  downloadAppModalVisible,
  setDownloadAppModalVisible,
}) => {
  return (
    <Modal
      title="Download the App"
      open={downloadAppModalVisible}
      onCancel={() => setDownloadAppModalVisible(false)}
      footer={null} // No default footer
    >
      <p
        style={{
          fontWeight: "500",
          color: "grey",
        }}
      >
        Please download our app to access features such as contacting guides,
        managing trips, and more!
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "0.5rem",
          flexWrap: "wrap",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            flex: "1",
            paddingTop: "0.5rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => (window.location.href = "https://apps.apple.com/us/app/wegether/id1638375019")}
        >
          <DownloadOnAppleStore />
        </div>
        <div
          style={{
            flex: "1",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "0.5rem",
            paddingBottom: "0.5rem",
          }}
          onClick={() => (window.location.href = "https://play.google.com/store/apps/details?id=com.wegether_tourist")}
        >
          <img
            src={"/GetItOnGooglePlay_Badge.png"}
            style={{
              width: "180px",
            }}
            alt="Get it on Google Play"
          />
        </div>
      </div>
    </Modal>
  );
};

export default DownloadWegetherModal;
